module.exports = __webpack_public_path__ + "img/tk-example.e13e915c.png";